const _ssrMode =
	__BW_ENV__.REACT_APP_SSR_MODE === 'true' || __BW_ENV__.REACT_APP_SSR_MODE === 'True' || __BW_ENV__.REACT_APP_SSR_MODE === 'TRUE';
export const isPrerender = () => _ssrMode || !!window['$prerender'] || navigator.userAgent.includes('Googlebot');
